<template>
  <div class="relative max-w-52 my-12 mx-auto">
    <font-awesome-icon class="float-right cursor-pointer hover:text-[var(--color-orange)]"
        icon="fa-pen" @click.prevent="toggleEdit" data-testid="icon_pen"/>
    <div class="absolute right-3 top-3 z-10">
      <input type='file' ref="uploader" id="imageUpload" accept=".png, .jpg, .jpeg" placeholder=""
             @change="uploadImage" class="hidden"/>
      <label for="imageUpload" class="hidden w-8 h-8 mb-0 rounded-full cursor-pointer"></label>
    </div>
    <div class="w-48 h-48 relative rounded-full border-8">
      <div v-if="!getCrop" class="w-full h-full rounded-full bg-cover bg-no-repeat bg-center"></div>
      <img v-else :src="getCrop" class="w-full h-full rounded-full bg-cover bg-no-repeat bg-center"
           alt=""/>
    </div>
  </div>
  <div class="mb-4" v-if="editMode">
      <vue-cropper ref="cropper"
                   :src="imageSource"
                   :aspect-ratio="1"
                   :crop-box-width="192"
                   :crop-box-height="192"
                   alt="Source Image"/>
    <div class="flex flex-wrap justify-center mx-auto box-border mt-3">
      <button @click="resetEditing" type="button" v-if="imageSource !== ''"
        class="btn-secondary mx-auto mt-3 py-3 px-9 text-base sm:text-xl" data-testid="btn_reset">
        {{ $t('ImageUploadComponent.reset') }}
      </button>
      <button @click="cancelEdit" class="btn-secondary mx-auto mt-3 py-3 px-9 text-base sm:text-xl" type="button"
        v-if="imageSource !== ''" data-testid="btn_imageCancel">
        {{ $t('ImageUploadComponent.cancel') }}
      </button>
      <button @click="saveAndUploadImage" type="button" v-if="imageSource !== ''"
        class="btn-primary-accent mx-auto mt-3 py-3 px-9 text-base sm:text-xl" data-testid="btn_imageSave">
        {{ $t('ImageUploadComponent.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';
// import { useField } from 'vee-validate';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'ImageUploadComponent',
  props: {
    name: {
      type: String,
      required: true,
    },
    initialImage: {
      type: String,
    },
  },
  components: { VueCropper },
  data() {
    return {
      editMode: false,
      imageSource: '',
      cropImg: this.initialImage || '',
      randomId: uuidv4(),
    };
  },
  computed: {
    getCrop() {
      if (this.cropImg) {
        return `${this.cropImg}?id=${this.randomId}`;
      }

      return '';
    },
  },
  methods: {
    uploadImage(e) {
      this.editMode = true;
      const file = e.target.files[0];
      if (file) {
        // Check file size (5 MB limit)
        const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
        // const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);

        if (file.size > maxSizeInBytes) {
          this.$toast.add({
            severity: 'error',
            summary: this.$t('ImageUploadComponent.fileTooLarge'),
            detail: '',
            life: 5000,
          });
          this.editMode = false;
          this.$refs.uploader.value = null;
          return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
          this.imageSource = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      }
    },
    resetEditing() {
      this.$refs.cropper.reset();
    },
    toggleEdit() {
      this.$refs.uploader.click();
    },
    cancelEdit() {
      this.editMode = false;
      this.$refs.uploader.value = null;
    },
    async saveAndUploadImage() {
      try {
        const base64Image = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.8);
        await this.$store.dispatch('uploadProfilePicture', base64Image);
        // this.cropImg = base64Image;
        this.imageSource = '';
        this.$refs.uploader.value = null;
        this.editMode = false;

        const newImageUrl = this.$store.getters.getUser?.picture_profile?.medium;

        if (newImageUrl) {
          this.cropImg = newImageUrl;
          this.updateImage(); // triggers cache-busting with new random ID
        }
        this.$toast.add({
          severity: 'success',
          summary: this.$t('ImageUploadComponent.successUpload'),
          detail: '',
          life: 3000,
        });
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ImageUploadComponent.errorUpload'),
          detail: '',
          life: 3000,
        });
      }
    },
    updateImage() {
      this.randomId = uuidv4();
    },
  },
  watch: {
    initialImage: {
      handler(newValue) {
        if (newValue && newValue !== this.cropImg) {
          this.cropImg = newValue;
          this.updateImage(); // Update cache-busting ID
        }
      },
      immediate: true,
    },
  },
  created() {
    /* this.field = useField(this.name, undefined, {
      type: 'text',
    });
    this.cropImg = this.field.value; */
    this.cropImg = this.initialImage;
  },
};
</script>
